import { useQuery } from '@tanstack/react-query';
import { useOkapiKy } from '@folio/stripes/core';

export const WIDGETS_QUERY_KEY = 'widgets';

export default function useWidgetsAPI() {
  const okapiKy = useOkapiKy();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [WIDGETS_QUERY_KEY],
    queryFn: () => okapiKy.get('widgets?limit=10000').json(),
    staleTime: 2 * 60 * 1000,
  });

  return {
    widgets: data?.widgets || [],
    totalRecords: data?.totalRecords || 0,
    isLoading,
    error,
    refetch,
  };
}
